import { useMemo } from "react";

/**
 * Pure-CSS confetti shower. ~60 small rotating squares fall from the top
 * with random colors, sizes, durations, delays. No deps, no canvas.
 * Mount once for ~6s of fall, unmount after.
 */
// Beacon: nur Blau / Weiß / Ink — kein Grün, kein Gold, kein Pink.
const COLORS = [
  "var(--accent-blue)",
  "var(--accent-blue-soft)",
  "var(--svo-weiss, #ffffff)",
  "var(--ink-200)",
  "var(--ink-300)",
];

interface Props {
  /** number of pieces */
  count?: number;
}

export function Confetti({ count = 80 }: Props) {
  const pieces = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const dur = 3.5 + Math.random() * 3.5;
      const delay = Math.random() * 1.5;
      const size = 6 + Math.random() * 10;
      const drift = -50 + Math.random() * 100;
      const color = COLORS[i % COLORS.length];
      const rotate = Math.random() * 360;
      const isCircle = Math.random() < 0.3;
      return { left, dur, delay, size, drift, color, rotate, isCircle, key: i };
    });
  }, [count]);

  return (
    <div className="confetti" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.key}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.isCircle ? "50%" : "2px",
            animationDuration: `${p.dur}s`,
            animationDelay: `${p.delay}s`,
            // CSS variables for the keyframe
            ["--drift" as string]: `${p.drift}px`,
            ["--rot" as string]: `${p.rotate}deg`,
          }}
        />
      ))}
    </div>
  );
}
